import React from 'react';
import * as Database from '../../helpers/Database';
import _ from 'lodash';
import '../../App.css';
import '../../bootstrap.css';


const conversionsLiter = {
  "cup": 4.22675,
  "dash": 1623.072,
  "finger": 90.1706666667,
  "fingertip": 202.884,
  "fist": 4.22675,
  "gallon": 0.264172,
  "handful": 16.907,
  "liter": 1,
  "milliliter": 1000,
  "palm": 5.635667,
  "pinch": 1623.072,
  "pint": 2.11338,
  "quart": 1.05669,
  "tablespoon": 67.628,
  "teaspoon": 202.884,
  "thumb": 67.628
};

const conversionsGram = {
  "gram": 1,
  "kilogram": 0.001,
  "ounce": 0.035274,
  "pound": 0.00220462
};

export default class FoodConversionTool extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      weightRules: {},
      volumeRules: {},
      fromServing: '',
      toServing: '',
      fromServingNumber: 1,
      toServingNumber: 1
    }
  }

  componentDidMount() {
    this.defaultVolumeServing = Object.keys(conversionsLiter)[0];
    this.defaultWeightServing = Object.keys(conversionsGram)[0];

    this.setState({
      weightRules: conversionsGram,
      volumeRules: conversionsLiter,
      fromServing: this.defaultVolumeServing,
      toServing: this.defaultVolumeServing
    });
  }

  componentWillUnmount() {
    Database.clearValueChangeCallback('servingRules');
  }

  fromServingNumberChange(e) {
    this.setState({ fromServingNumber: e.target.value });
  }

  toServingNumberChange(e) {
    this.setState({ toServingNumber: e.target.value });
  }

  fromServingChange(e) {
    let isVolume = this.state.volumeRules && this.state.volumeRules[e.target.value];
    let wasVolume = this.state.volumeRules && this.state.volumeRules[this.state.toServing];
    let selectedServing = this.state.toServing;
    if (wasVolume && !isVolume) {
      selectedServing = this.defaultWeightServing;
    } else if (isVolume && !wasVolume) {
      selectedServing = this.defaultVolumeServing;
    }

    this.setState({ fromServing: e.target.value, toServing: selectedServing });
  }

  toServingChange(e) {
    this.setState({ toServing: e.target.value });
  }

  async compareServingsAsync(requestedServing, contenderServing) {
    if (!requestedServing) {
      return { hasServingMatch: false };
    }

    if (requestedServing === contenderServing) {
      return { hasServingMatch: true, conversionFactor: 1 };
    }

    let requestedServingInLiterOrGram =
      conversionsLiter[requestedServing] ? 1 / conversionsLiter[requestedServing] : 1 / conversionsGram[requestedServing];

    if (!requestedServingInLiterOrGram) {
      return { hasServingMatch: false };
    }

    let contenderServingInLiterOrGram =
      conversionsLiter[contenderServing] ? conversionsLiter[contenderServing] : conversionsGram[contenderServing];

    if (!contenderServingInLiterOrGram) {
      return { hasServingMatch: false };
    }

    let conversionFactor = requestedServingInLiterOrGram * contenderServingInLiterOrGram;
    return { hasServingMatch: true, conversionFactor }
  }

  async compute() {
    if (!this.state.fromServingNumber || !this.state.toServingNumber) {
      this.setState({ errorMsg: 'Serving numbers are required!' });
    } else {
      let { hasServingMatch, conversionFactor } = await this.compareServingsAsync(this.state.fromServing, this.state.toServing);
      let servingNumber = hasServingMatch ?
        (conversionFactor ? conversionFactor * this.state.fromServingNumber : this.state.fromServingNumber) / this.state.toServingNumber :
        this.state.fromServingNumber / this.state.toServingNumber;

      let result = _.round(servingNumber, 4);
      this.setState({ result: result, errorMsg: '' });
      this.props.onCompute(result);
    }
  }

  render() {
    return (
      <div style={{ margin: '10px', padding: '10px', border: '.5px solid' }}>
        <div>
          <b>User ate:</b>&nbsp;
          <input type='number' style={{ width: '50px' }} value={this.state.fromServingNumber} onChange={this.fromServingNumberChange.bind(this)} />&nbsp;
          <select onChange={this.fromServingChange.bind(this)}>
            {
              Object.keys(conversionsLiter).map(name =>
                <option>{name}</option>
              )
            }
            {
              Object.keys(conversionsGram).map(name =>
                <option>{name}</option>
              )
            }
          </select>
        </div>
        <div>
          <b>Serving option says:</b>&nbsp;
          <input type='number' style={{ width: '50px' }} value={this.state.toServingNumber} onChange={this.toServingNumberChange.bind(this)} />&nbsp;
          <select onChange={this.toServingChange.bind(this)}>
            {
              !this.state.fromServing || (this.state.volumeRules && this.state.volumeRules[this.state.fromServing]) ?
                Object.keys(this.state.volumeRules).map(name =>
                  <option>{name}</option>
                ) : (<span />)
            }
            {
              !this.state.fromServing || (this.state.weightRules && this.state.weightRules[this.state.fromServing]) ?
                Object.keys(this.state.weightRules).map(name =>
                  <option>{name}</option>
                ) : (<span />)
            }
          </select>
          <div><input type='submit' value='Compute' onClick={this.compute.bind(this)} /></div>
          <div style={{ color: 'red' }}>{this.state.errorMsg ? this.state.errorMsg : ''}</div>
          <hr />
          <b>Serving number is: </b> <span style={{ margin: '5px', width: '100px', padding: "5px", backgroundColor: 'white' }}>{this.state.result ? this.state.result : ''}</span>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/foodLogging/FoodConversionTool.js